{
  "/gallery/opbouw-1.avif": [
    {
      "url": "/image-variants/gallery/opbouw-1.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-1.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-10.avif": [
    {
      "url": "/image-variants/gallery/opbouw-10.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-10.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-11.avif": [
    {
      "url": "/image-variants/gallery/opbouw-11.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-11.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-12.avif": [
    {
      "url": "/image-variants/gallery/opbouw-12.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-12.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-13.avif": [
    {
      "url": "/image-variants/gallery/opbouw-13.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-13.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-14.avif": [
    {
      "url": "/image-variants/gallery/opbouw-14.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-14.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-15.avif": [
    {
      "url": "/image-variants/gallery/opbouw-15.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-15.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-16.avif": [
    {
      "url": "/image-variants/gallery/opbouw-16.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-16.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-17.avif": [
    {
      "url": "/image-variants/gallery/opbouw-17.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-17.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-18.avif": [
    {
      "url": "/image-variants/gallery/opbouw-18.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-18.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-19.avif": [
    {
      "url": "/image-variants/gallery/opbouw-19.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-19.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-2.avif": [
    {
      "url": "/image-variants/gallery/opbouw-2.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-2.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-20.avif": [
    {
      "url": "/image-variants/gallery/opbouw-20.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-20.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-21.avif": [
    {
      "url": "/image-variants/gallery/opbouw-21.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-21.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-22.avif": [
    {
      "url": "/image-variants/gallery/opbouw-22.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-22.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-23.avif": [
    {
      "url": "/image-variants/gallery/opbouw-23.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-23.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-24.avif": [
    {
      "url": "/image-variants/gallery/opbouw-24.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-24.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-25.avif": [
    {
      "url": "/image-variants/gallery/opbouw-25.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-25.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-26.avif": [
    {
      "url": "/image-variants/gallery/opbouw-26.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-26.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-27.avif": [
    {
      "url": "/image-variants/gallery/opbouw-27.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-27.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-28.avif": [
    {
      "url": "/image-variants/gallery/opbouw-28.avif",
      "width": 640,
      "height": 480
    },
    {
      "url": "/gallery/opbouw-28.avif",
      "width": 1400,
      "height": 1050
    }
  ],
  "/gallery/opbouw-29.avif": [
    {
      "url": "/image-variants/gallery/opbouw-29.avif",
      "width": 640,
      "height": 852
    },
    {
      "url": "/gallery/opbouw-29.avif",
      "width": 1052,
      "height": 1400
    }
  ],
  "/gallery/opbouw-3.avif": [
    {
      "url": "/image-variants/gallery/opbouw-3.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-3.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-30.avif": [
    {
      "url": "/image-variants/gallery/opbouw-30.avif",
      "width": 640,
      "height": 852
    },
    {
      "url": "/gallery/opbouw-30.avif",
      "width": 1052,
      "height": 1400
    }
  ],
  "/gallery/opbouw-31.avif": [
    {
      "url": "/image-variants/gallery/opbouw-31.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-31.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-32.avif": [
    {
      "url": "/image-variants/gallery/opbouw-32.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-32.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-33.avif": [
    {
      "url": "/image-variants/gallery/opbouw-33.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-33.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-34.avif": [
    {
      "url": "/image-variants/gallery/opbouw-34.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-34.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-35.avif": [
    {
      "url": "/image-variants/gallery/opbouw-35.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-35.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-36.avif": [
    {
      "url": "/image-variants/gallery/opbouw-36.avif",
      "width": 640,
      "height": 1137
    },
    {
      "url": "/gallery/opbouw-36.avif",
      "width": 788,
      "height": 1400
    }
  ],
  "/gallery/opbouw-37.avif": [
    {
      "url": "/image-variants/gallery/opbouw-37.avif",
      "width": 640,
      "height": 1137
    },
    {
      "url": "/gallery/opbouw-37.avif",
      "width": 788,
      "height": 1400
    }
  ],
  "/gallery/opbouw-38.avif": [
    {
      "url": "/image-variants/gallery/opbouw-38.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/gallery/opbouw-38.avif",
      "width": 1400,
      "height": 788
    }
  ],
  "/gallery/opbouw-4.avif": [
    {
      "url": "/image-variants/gallery/opbouw-4.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-4.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-5.avif": [
    {
      "url": "/image-variants/gallery/opbouw-5.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-5.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-6.avif": [
    {
      "url": "/image-variants/gallery/opbouw-6.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-6.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-7.avif": [
    {
      "url": "/image-variants/gallery/opbouw-7.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-7.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-8.avif": [
    {
      "url": "/image-variants/gallery/opbouw-8.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-8.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/opbouw-9.avif": [
    {
      "url": "/image-variants/gallery/opbouw-9.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/opbouw-9.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/realisatie-10x3-1.avif": [
    {
      "url": "/image-variants/gallery/realisatie-10x3-1.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/realisatie-10x3-1.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/realisatie-10x3-10.avif": [
    {
      "url": "/image-variants/gallery/realisatie-10x3-10.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/realisatie-10x3-10.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/realisatie-10x3-2.avif": [
    {
      "url": "/image-variants/gallery/realisatie-10x3-2.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/realisatie-10x3-2.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/realisatie-10x3-3.avif": [
    {
      "url": "/image-variants/gallery/realisatie-10x3-3.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/realisatie-10x3-3.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/realisatie-10x3-4.avif": [
    {
      "url": "/image-variants/gallery/realisatie-10x3-4.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/realisatie-10x3-4.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/realisatie-10x3-5.avif": [
    {
      "url": "/image-variants/gallery/realisatie-10x3-5.avif",
      "width": 640,
      "height": 1137
    },
    {
      "url": "/gallery/realisatie-10x3-5.avif",
      "width": 788,
      "height": 1400
    }
  ],
  "/gallery/realisatie-10x3-6.avif": [
    {
      "url": "/image-variants/gallery/realisatie-10x3-6.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/realisatie-10x3-6.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/realisatie-10x3-7.avif": [
    {
      "url": "/image-variants/gallery/realisatie-10x3-7.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/realisatie-10x3-7.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/realisatie-10x3-8.avif": [
    {
      "url": "/image-variants/gallery/realisatie-10x3-8.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/realisatie-10x3-8.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/gallery/realisatie-10x3-9.avif": [
    {
      "url": "/image-variants/gallery/realisatie-10x3-9.avif",
      "width": 640,
      "height": 853
    },
    {
      "url": "/gallery/realisatie-10x3-9.avif",
      "width": 1050,
      "height": 1400
    }
  ],
  "/blog/afdekking.avif": [
    {
      "url": "/image-variants/blog/afdekking.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/afdekking.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/desinfectie.avif": [
    {
      "url": "/image-variants/blog/desinfectie.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/desinfectie.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/doseersysteem.avif": [
    {
      "url": "/image-variants/blog/doseersysteem.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/doseersysteem.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/glasparels-filterzand.avif": [
    {
      "url": "/image-variants/blog/glasparels-filterzand.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/glasparels-filterzand.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/groen-water.avif": [
    {
      "url": "/image-variants/blog/groen-water.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/groen-water.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/inbouwdelen-design.avif": [
    {
      "url": "/image-variants/blog/inbouwdelen-design.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/inbouwdelen-design.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/kleine-tuin-zwembad.avif": [
    {
      "url": "/image-variants/blog/kleine-tuin-zwembad.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/kleine-tuin-zwembad.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/lekdetectie-waterpeil.avif": [
    {
      "url": "/image-variants/blog/lekdetectie-waterpeil.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/lekdetectie-waterpeil.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/lenteklaar.avif": [
    {
      "url": "/image-variants/blog/lenteklaar.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/lenteklaar.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/monoblok-vs-bouwkundig.avif": [
    {
      "url": "/image-variants/blog/monoblok-vs-bouwkundig.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/monoblok-vs-bouwkundig.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/najaar-zwemmen.avif": [
    {
      "url": "/image-variants/blog/najaar-zwemmen.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/najaar-zwemmen.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/polyester-vs-pp.avif": [
    {
      "url": "/image-variants/blog/polyester-vs-pp.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/polyester-vs-pp.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/pomp.avif": [
    {
      "url": "/image-variants/blog/pomp.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/pomp.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/renovatie.avif": [
    {
      "url": "/image-variants/blog/renovatie.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/renovatie.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/stappenplan-aanleg.avif": [
    {
      "url": "/image-variants/blog/stappenplan-aanleg.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/stappenplan-aanleg.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/veilige-afdekking.avif": [
    {
      "url": "/image-variants/blog/veilige-afdekking.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/veilige-afdekking.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/verborgen-kosten.avif": [
    {
      "url": "/image-variants/blog/verborgen-kosten.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/verborgen-kosten.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/vergunning-zwembad.avif": [
    {
      "url": "/image-variants/blog/vergunning-zwembad.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/vergunning-zwembad.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/warmtepomp.avif": [
    {
      "url": "/image-variants/blog/warmtepomp.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/warmtepomp.avif",
      "width": 1280,
      "height": 720
    }
  ],
  "/blog/winterklaar.avif": [
    {
      "url": "/image-variants/blog/winterklaar.avif",
      "width": 640,
      "height": 360
    },
    {
      "url": "/blog/winterklaar.avif",
      "width": 1280,
      "height": 720
    }
  ]
}